import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RfariassRoutingModule } from './rfarias-routing.module';



@NgModule({
  imports: [
    RfariassRoutingModule,
    CommonModule
  ],
  declarations: [
  ]
})
export class RfariasModule { }
